var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceLaugh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C123.461 16 16 123.419 16 256S123.461 496 256 496S496 388.581 496 256S388.539 16 256 16ZM336.043 160C353.723 160 368.012 174.25 368.012 192S353.723 224 336.043 224C318.242 224 303.953 209.75 303.953 192S318.242 160 336.043 160ZM175.957 160C193.758 160 208.047 174.25 208.047 192S193.758 224 175.957 224C158.277 224 143.988 209.75 143.988 192S158.277 160 175.957 160ZM263.992 432H248.008C174.625 432 113.957 377 105.117 306C103.906 296.5 111.414 288 120.98 288H391.02C400.586 288 408.094 296.375 406.883 306C398.043 377 337.375 432 263.992 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceLaugh);
export default __webpack_public_path__ + "static/media/face-laugh.c0cf4de0aaf676abb89484570e4d00a1.svg";
export { ForwardRef as ReactComponent };